/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  speakers: [],
  communicationTopics: [],
  pagination: {
    current_page: 1,
    per_page: 24,
    total: 0,
  },
};

const actions = {
  async getAllBlocks({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/blocks?${new URLSearchParams(payload)}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async getCommunicationTopics({ commit }, payload) {
    const response = await axios.get("blocks/communication-topics", {
      params: payload,
    });
    if (response.status === 200) {
      commit("SET_LIST_COMMUNICATION_TOPICS", response.data.data);
    }
    return response;
  },

  createCommunicationTopics({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("blocks/communication-topics", payload)
        .then((response) => {
          resolve(response);
          commit("ADD_LIST_COMMUNICATION_TOPICS", response.data.data.block[0]);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateCommunicationTopics({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`blocks/communication-topics/${id}`, payload)
        .then((response) => {
          resolve(response);
          commit(
            "UPDATE_LIST_COMMUNICATION_TOPICS",
            response.data.data.block[0]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCommunicationTopicsCurrentPage({ commit }, data) {
    commit("SET_COMMUNICATION_TOPICS_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setCommunicationTopicsPerPage({ commit }, data) {
    commit("SET_COMMUNICATION_TOPICS_PER_PAGE", data);
  },

  /**
   * Create block
   * @param commit
   * @param payload
   * @returns {Promise<{data: [], status: boolean}|{data: (*|*[]), status: boolean}>}
   */
  createBlock({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("blocks", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Update block
   */
  updateBlock({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`blocks/${id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete block
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async deleteBlock({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`blocks/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete block
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async changeBlockOrder({ commit }, payload) {
    try {
      const response = await axios.post("/blocks/change-block-order", payload);
      return response.data.status_code === 200;
    } catch (e) {
      return false;
    }
  },

  async duplicate({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/blocks/${id}/duplicate`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async createGameTable({ commit }, form) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/blocks/${form.id}/game-table`, form.payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Get all speaker
   * @param commit
   * @returns {Promise<*>}
   */
  async getAllSpeakers({ commit }) {
    const response = await axios.get("speakers");
    if (response.data.status_code === 200) {
      commit("SET_SPEAKERS", response.data.data);
    }
    return response;
  },

  /**
   * Add Speaker
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async addSpeaker({ commit }, payload) {
    return await axios.post("speakers", payload);
  },

  /**
   * Delete speaker
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async deleteSpeaker({ commit }, id) {
    return await axios.delete("speakers/" + id);
  },

  async transferBlock({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/blocks/${id}/transfer`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_SPEAKERS(state, data) {
    state.speakers = data;
  },

  SET_LIST_COMMUNICATION_TOPICS(state, data) {
    state.communicationTopics = data.data;
    state.pagination = data.pagination;
  },

  ADD_LIST_COMMUNICATION_TOPICS(state, data) {
    state.communicationTopics.push(data);
  },

  UPDATE_LIST_COMMUNICATION_TOPICS(state, data) {
    const index = state.communicationTopics.findIndex((u) => u.id === data.id);
    if (index >= 0) {
      state.communicationTopics.splice(index, 1, data);
    }
  },

  SET_COMMUNICATION_TOPICS_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },

  SET_COMMUNICATION_TOPICS_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
